import { CancelledOfferView, Modal } from "components";

import _ from "lodash";
import { useCancelledOffer } from "hooks/data/use-offers";
import { useAppSearch } from "_graphql/cache/auth";

export default function ViewOfferCancellationReasonContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useAppSearch();
  const { offer, loading } = useCancelledOffer({
    offerId: (searchParams.id as string) || "",
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title="Offer Details"
      loading={loading}
      description="View details of the cancelled offer"
      // hideActions
      // hidePadding
    >
      {/* {JSON.stringify(offer, null, 2)} */}
      <CancelledOfferView offer={offer} />
    </Modal>
  );
}
